import clsx from 'clsx';
import LessonCard from './LessonCard';
import styles from './SampleLessons.module.css';

export default function SampleLessons({content}) {
    const count = content.lessons.length;
    const threeAcross = count % 3 === 0 && count % 4 !== 0;

    return (
        // Content's own secondaryAction href points at this exact id (`#ch-home-lessons`) and can't
        // change - content/hotmaths.js is shared with Home.js and stays untouched.
        <section id="ch-home-lessons" className={styles.section} aria-labelledby="home-lessons-heading">
            <div className={styles.inner}>
                <div className={styles.head}>
                    <h2 id="home-lessons-heading" className={styles.heading}>{content.heading}</h2>
                    <div className={styles.intro}>
                        <p>{content.intro}</p>
                        <p className={styles.note}><em>{content.note}</em></p>
                    </div>
                </div>

                {/* 4 -> 2x2 -> 1, never 3+1; a multiple of three goes three across - see SampleLessons.module.css. */}
                <div className={clsx(styles.grid, threeAcross && styles.gridThree)}>
                    {content.lessons.map((lesson, index) => (
                        <LessonCard key={lesson.syllabusId} lesson={lesson} index={index}/>
                    ))}
                </div>
            </div>
        </section>
    );
}
